<template>
  <div class="sr_box_slim lipad">
    <div class="hb_columns">
      <div class="hb_column sr_bold">
        {{ propObj.date | date_reverse_filter }}
      </div>
      <div class="hb_column">
        {{ getDriverName(propObj) }}
      </div>
    </div>
    <div class="hb_columns">
      <div class="hb_column_1">
        Km/h&nbsp;{{ propObj.speed }}&nbsp;
        <span v-if="classMessage(propObj.message)" class="keyKm">
          - {{ propObj.message | mssg_filter_counter }}</span
        >
        <span v-else class="kmmn">
          - {{ propObj.message | mssg_filter_counter }}</span
        >
      </div>
      <div class="hb_column_2">
        {{ calcSondaString(propObj, vehicleObj) }}
      </div>
    </div>
    <div class="hb_columns">
      <div class="truncate sr_small" :title="propObj.address | pipe_filter">
        {{ propObj.address | pipe_filter }}
      </div>
    </div>
  </div>
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'HistoryBox',
  mixins: [UtilityMixin],
  props: {
    propObj: {
      default: null,
      type: Object,
    },
    vehicleObj: {
      default: null,
      type: Object,
    },
    selectedCod: {
      default: '',
      type: String,
    },
  },

  methods: {
    goHistory() {
      ServiceBus.$emit('showHistory')
    },
    classMessage: function (value) {
      if (value.indexOf('KT ') >= 0) {
        return true
      }
      return false
    },

    calcUM(s) {
      if (s == 'T') return '°'
      if (s == 'C') return 'L'
      return ''
    },
    calcSondaString(obj, vobj) {
      const vm = this
      let s = ''
      let sep = ''
      let um = ''
      if (vobj.sonda_1.length > 0) {
        s =
          s +
          vobj.sonda_1 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v1) +
          vm.calcUM(vobj.sonda_1)
        sep = ' - '
      }
      if (vobj.sonda_2.length > 0) {
        s =
          s +
          sep +
          vobj.sonda_2 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v2) +
          vm.calcUM(vobj.sonda_2)
        sep = ' - '
      }
      if (vobj.sonda_3.length > 0) {
        if (obj.sonda_1 == 'T') {
          um = '°'
        }
        s =
          s +
          sep +
          vobj.sonda_3 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v3) +
          vm.calcUM(vobj.sonda_3)
        sep = ' - '
      }
      if (vobj.sonda_4.length > 0) {
        s =
          s +
          sep +
          vobj.sonda_4 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v4) +
          vm.calcUM(vobj.sonda_4)
      }
      return s
    },
  },
}
</script>
<style scoped>
.hb_columns {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.hb_column_1,
.hb_column_2 {
  padding: 3px;
}

.hb_column_1 {
  flex: 1;
}

.hb_column_2 {
  flex: 0.3;
}

.lipad {
  padding-top: 5px;
  padding-bottom: 5px;
}
.kmmn {
  font-size: 10px;
  color: blue;
  padding-right: 3px;
  font-weight: bold;
}

.keyKm {
  font-size: 10px;
  color: red;
  padding-right: 3px;
  font-weight: bold;
}
</style>
